/**
 * Shared Motion (motion/react) timing, so every page moves the same way
 * rather than each picking its own curve. Values are the ones specified for
 * this product: 0.18s for opacity/transform with this ease, 0.12s for pure
 * colour changes (handled in CSS, not here), 0.3s ease-in-out for combined
 * transform+background.
 */

export const EASE = [0.165, 0.84, 0.44, 1] as const;

/** A panel or card fading and rising into place. */
export const fadeUp = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.3, ease: EASE } },
};

/** Wrap a list of `fadeUp` children in this to stagger their entrance. */
export const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
};
